import initSlickWithArrowEvent from "../components/slick-utils";

function initMaierSectionShopMediaSlider(slider) {
    let slick = initSlickWithArrowEvent(
        $(slider),
        {
            dots: true,
            arrows: false,
            dotsClass: 'maier-section-shop-media-dots',
            autoplay: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                }
            ]
        }
    );

    slick.on('afterChange', function(event, slick, currentSlide) {
        var activeDotEl = $(event.target).find('.maier-section-shop-media').find('li.slick-active');
        if (activeDotEl.get(0)) {
            activeDotEl.get(0).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    });
}

function observeMaierSectionShopMediaSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initMaierSectionShopMediaSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-section-shop-media').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-section-shop-media').forEach(slider => initMaierSectionShopMediaSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierSectionShopMediaSlider() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeMaierSectionShopMediaSlider();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierSectionShopMediaSlider);
} else {
    setupMaierSectionShopMediaSlider();
}